import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../userContext';
import Logo from '../images/logo.png';
import { getAuth, signOut } from 'firebase/auth';

function ErrorPage() {
  const navigate = useNavigate();
  const { user } = useUser();

  const handleContactUs = () => {
    // Redirect to your contact page or open a mailto link
    window.location.href = 'mailto:support@groupchatheroes.com'; // Replace with your contact URL or email
  };

  const handleSignOut = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        console.log('User signed out');
        navigate('/login');
      })
      .catch((error) => {
        console.error('Error signing out:', error);
      });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-white via-gray-100 to-gray-300">
      <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-2xl text-center max-w-sm w-full">
        <img src={Logo} alt="Group Chat Heroes Logo" className="mx-auto h-8 mb-6" />
        <h1 className="text-xl font-extrabold text-red-600 dark:text-red-400 mb-4">
          Oops! Something went wrong
        </h1>
        <p className="text-gray-700 dark:text-gray-300 mb-6">
          We're unable to load your account information. Please try signing out and logging in again or contact support for help.
        </p>
        <div className="space-y-4">
          {user && (
            <button
              onClick={handleSignOut}
              className="btn w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-md focus:outline-none shadow-md"
            >
              Sign Out
            </button>
          )}
          <button
            onClick={handleContactUs}
            className="btn w-full bg-violet-500 hover:bg-violet-600 text-white py-2 rounded-md focus:outline-none shadow-md"
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
}

// Studio-specific 404 component
export function Studio404() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{
      background: 'linear-gradient(135deg, #2C3E50, #34495E)',
      fontFamily: '"Share Tech Mono", monospace'
    }}>
      <div className="text-center px-6">
        <div className="text-8xl mb-6">🎮</div>
        <h1 className="text-4xl font-black mb-4 tracking-wider" style={{
          color: '#F1C40F',
          textShadow: '2px 2px 0px #E67E22'
        }}>
          404 - PAGE NOT FOUND
        </h1>
        <p className="text-lg font-bold mb-8" style={{color: '#ECF0F1'}}>
          Looks like this studio page doesn't exist or has been moved.
        </p>
        <div className="space-y-4">
          <a
            href="/studio/dashboard"
            className="inline-flex items-center px-6 py-3 font-bold text-white rounded-md transition-all duration-100 mr-4"
            style={{
              background: 'linear-gradient(135deg, #E74C3C, #C0392B)',
              border: '2px solid #F1C40F',
              textShadow: '1px 1px 0px #A93226'
            }}
          >
            🏠 GO TO DASHBOARD
          </a>
          <a
            href="/studio/campaigns"
            className="inline-flex items-center px-6 py-3 font-bold rounded-md transition-all duration-100"
            style={{
              background: 'rgba(52, 73, 94, 0.6)',
              border: '2px solid #F1C40F',
              color: '#F1C40F'
            }}
          >
            📊 VIEW CAMPAIGNS
          </a>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;